export var FormItemType = function() {

};

FormItemType.TEXT = 'text';
FormItemType.AWESOME_BOX = 'awesomeBox';
FormItemType.AWESOME_DROPDOWN = 'awesomeDropdown';
FormItemType.FORMULA_BUILDER = 'formulaBuilder';
FormItemType.COMBO_BOX = 'comboBox';
FormItemType.LIST = 'list';
FormItemType.TEXT_INPUT = 'textInput';
FormItemType.TIME_PICKER = 'timePicker';
FormItemType.FEEDBACK_BOX = 'feedbackBox';
FormItemType.PASSWORD_INPUT = 'passwordInput';
FormItemType.TEXT_AREA = 'textArea';
FormItemType.TINYMCE_TEXT_AREA = 'tinymceTextArea';
FormItemType.TAG_INPUT = 'tagInput';
FormItemType.DATE_PICKER = 'datePicker';
FormItemType.RANGE_PICKER = 'range_date_picker';
FormItemType.CHECKBOX = 'checkbox';
FormItemType.SEPARATED_BOX = 'separatedBox';
FormItemType.FILE_BROWSER = 'fileBrowser';
FormItemType.IMAGE_BROWSER = 'imageBrowser';
FormItemType.IMAGE_AVD_BROWSER = 'imageADVBrowser';
FormItemType.CAMERA_BROWSER = 'cameraBrowser';
FormItemType.IMAGE_CUT = 'imageCutArea';
FormItemType.INSIDE_EDITOR = 'insideEditor';
FormItemType.IMAGE = 'image';
FormItemType.COLOR_PICKER = 'colorPicker';

export var WidgetNamesDic = function() {

};

WidgetNamesDic.ERROR_TOOLTIP = 'errorToolTip';

WidgetNamesDic.EDIT_VIEW_FORM_ITEM = 'editViewFormItem';
WidgetNamesDic.EDIT_VIEW_SUB_FORM_ITEM = 'editViewSubFormItem';
WidgetNamesDic.PAGING = 'paging';
WidgetNamesDic.PAGING_2 = 'paging_2';
WidgetNamesDic.NO_RESULT_BOX = 'no_result_box';
WidgetNamesDic.VIEW_MIN_TAB_BAR = 'view_min_tab_bar';
WidgetNamesDic.VIEW_MIN_TAB = 'view_min_tab';
WidgetNamesDic.NOTIFICATION_BAR = 'notification_bar';